
import FbxButton from '@/components/fbx-button.vue';
import ListRefresh from '@/components/ListRefresh.vue';
import NearbyTrailerResultCard from '@/components/NearbyTrailerResultCard.vue';
import NearbyTrailerResult from '@/types/NearbyTrailerResult';
import NoTrailersAvailable from '@/components/NoTrailersAvailable.vue';
import { defineComponent } from 'vue';
import ExpandableBadge from '@/components/ExpandableBadge.vue';
import { mapGetters } from 'vuex';

export default defineComponent({
    data(): {
        isListExpanded: boolean;
    } {
        return {
            isListExpanded: false,
        };
    },
    methods: {
        switchExpand(): void {
            this.isListExpanded = !this.isListExpanded;
        },
        navigateToEnterTrailer(): void {
            this.$router.push({ name: 'EnterTrailer' });
        },
        navigateToDriverLanding() {
            this.$router.push({ name: 'DriverLanding' });
        },
    },
    components: {
        ListRefresh,
        NearbyTrailerResultCard,
        NoTrailersAvailable,
        FbxButton,
        ExpandableBadge,
    },
    props: {
        isLoading: Boolean,
        isRefreshing: Boolean,
    },
    computed: {
        ...mapGetters({
            trailerAssociationsEnabled: 'trailerAssociationsEnabled',
        }),
        attachButtonText(): string {
            return this.noResults ? 'Attach Trailer' : 'Attach Another Trailer';
        },
        noResults(): boolean {
            return !this.isLoading && this.results.length === 0;
        },
        results(): NearbyTrailerResult[] {
            return this.$store.getters.getNearbyTrailerResults === undefined
                ? []
                : this.$store.getters.getNearbyTrailerResults;
        },
        shouldHideTrailerListing(): boolean {
            return this.isListExpanded && window.innerWidth > 576;
        },
    },
    mounted() {
        window.addEventListener('resize', () => (this.isListExpanded = false));
    },
    unmounted() {
        window.removeEventListener(
            'resize',
            () => (this.isListExpanded = false)
        );
    },
});
